import apiClient from '../axios';

export default {
    getModulosporCurso(id) {
        return apiClient.get(`/modulos/curso/${id}`);
    },
}